// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  envName: 'main',
  googleMapKey: 'AIzaSyBTQUONuqiWMf5-Juwv7Kw33uuxP45pOBw',
  googleMapId: '8327008f8140c881',
  apiUrl: 'https://e42or7c6bf.execute-api.ap-northeast-1.amazonaws.com/main/',
  apiKey: '9J5ldxO0rN2l8t0Com3mk1vMBku0yd7r4S5zN2Uo'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
